import './summary.css'
import CountUp from 'react-countup';
import display_photo from '../../assets/display_photo.jpg'

const Summary = () => {
    return (
        <section className="summary" id="me">
            <img className="summary_photo" src={display_photo} alt="Prince Geary Dymosco, Full-stack Developer" width="20"/>
            <div className="summary_content">
                <h2 className="summary_title">Behind the Code</h2>
                <div className="summary_text">
                    <p>
                        Prince is an electronics engineer turned software developer with a passion for solving problems through code. He graduated with distinction from the Technological University of the Philippines Visayas.
                    </p>
                    <p>
                        He began his career as an Equipment Engineer at Analog Devices Inc., where he earned a Spot Award just two months in for his key contribution to the accelerated release of 5G test machines.
                    </p>
                    <p>
                        During his semiconductor career, Prince rediscovered his love for programming by building automation tools and dashboards that delivered real-time production insights and supported data-driven decisions.
                    </p>
                    <p>
                        Driven by this passion, he transitioned fully into software development and now leads CRM development for pet grooming service providers at a UK-based tech company serving global clients.
                    </p>
                    <p>
                        Outside of work, he enjoys nature, spending time with friends, and exploring new technologies or side projects from his favorite cafés.
                    </p>
                </div>
                <div className="summary_years">
                    <div className="summary_years_item">
                        <div><CountUp className="summary_years_item_count_up" end={4} duration={1} enableScrollSpy={true}/> <span className='summary_years_item_count_up'>+</span></div>
                        <div className="summary_years_description">Years in Software Development</div>
                    </div>
                    <div className="summary_years_item">
                        <CountUp className="summary_years_item_count_up" end={4} duration={1} enableScrollSpy={true}/> 
                        <div className="summary_years_description">Web Projects</div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Summary